module.exports = __webpack_public_path__ + "img/e868b6b.png";